import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getchargexp, updateChargeExp, deleteChargeExp } from "../Redux/Actions/ChargeExpActions";
import { current } from "../Redux/Actions/AuthActions";
import { Table, Button, Modal, Form, Row, Col } from 'react-bootstrap';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import './ListRapports.css';
import axios from 'axios';

function EtatDepenses() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(current());
    dispatch(getchargexp());
  }, [dispatch]);

  const user = useSelector((state) => state.AuthReducer.user);
  const chargeExpl = useSelector((state) => state.ChargeExpReducer.ChargeExpl);

  // Dates par défaut (mois en cours)
  const getInitialDates = () => {
    const today = new Date();
    const start = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];
    const end = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split('T')[0];
    return { start, end };
  };

  const initialDates = getInitialDates();

  const [localisation, setLocalisation] = useState("All");
  const [objet, setObjet] = useState("All");
  const [startDate, setStartDate] = useState(initialDates.start);
  const [endDate, setEndDate] = useState(initialDates.end);
  const [filteredData, setFilteredData] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);

  // States for Editing
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedCharge, setSelectedCharge] = useState(null);
  const [customCategories, setCustomCategories] = useState([]);
  const [editEmplacement, setEditEmplacement] = useState("");
  const [editObjet, setEditObjet] = useState("");
  const [editCustomObjet, setEditCustomObjet] = useState("");
  const [editDate, setEditDate] = useState("");
  const [editAmount, setEditAmount] = useState("");
  const [editExpense, setEditExpense] = useState("");
  const [editExplanation, setEditExplanation] = useState("");

  const fetchCategories = () => {
    axios.get('/api/ChargeExp/GetChargeCategories')
      .then(res => {
        setCustomCategories(res.data.categories || []);
      })
      .catch(err => console.error("Error fetching categories:", err));
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleShowEdit = (charge) => {
    setSelectedCharge(charge);
    setEditEmplacement(charge.localisation || "");
    setEditDate(charge.DateCollect ? charge.DateCollect.slice(0, 10) : "");
    setEditAmount(charge.TotalAmount || "");
    setEditExpense(charge.DailyExpenses || "");
    setEditExplanation(charge.feedback || "");

    const standardCategories = [
      "Loyers", "Paiement des Crédits", "Agios", "Déclaration fiscales", "Echéancier Fiscal",
      "Les salaires", "STEG", "SONEDE", "CNSS", "Assurance", "entretien voiture", "Carburant",
      "Opérateurs téléphoniques", "Opérateur Internet", "Fournitures de Bureau", "Achat jouets",
      "Achats Candybar"
    ];

    const isStandard = standardCategories.includes(charge.objet) || customCategories.some(c => c.name === charge.objet);
    if (isStandard) {
      setEditObjet(charge.objet || "");
      setEditCustomObjet("");
    } else {
      setEditObjet("Autre");
      setEditCustomObjet(charge.objet || "");
    }

    setShowEditModal(true);
  };

  const handleDelete = (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cette charge d'exploitation ?")) {
      dispatch(deleteChargeExp(id));
    }
  };

  const handleUpdate = (e) => {
    e.preventDefault();

    if (!editEmplacement || editEmplacement === "Choisissez un emplacement...") {
      alert("Veuillez choisir un emplacement.");
      return;
    }
    if (!editObjet || editObjet === "Types de Charges...") {
      alert("Veuillez choisir l'objet de la charge.");
      return;
    }
    if (editObjet === "Autre" && !editCustomObjet.trim()) {
      alert("Veuillez saisir le nom de la nouvelle charge.");
      return;
    }
    if (!editDate) {
      alert("Veuillez saisir une date valide.");
      return;
    }
    if (!editAmount || parseFloat(editAmount) <= 0) {
      alert("Veuillez saisir un montant supérieur à 0.");
      return;
    }
    if (!editExplanation) {
      alert("Veuillez donner une explication.");
      return;
    }

    const finalObjet = editObjet === "Autre" ? editCustomObjet.trim() : editObjet;

    const isStandard = [
      "Loyers", "Paiement des Crédits", "Agios", "Déclaration fiscales", "Echéancier Fiscal",
      "Les salaires", "STEG", "SONEDE", "CNSS", "Assurance", "entretien voiture", "Carburant",
      "Opérateurs téléphoniques", "Opérateur Internet", "Fournitures de Bureau", "Achat jouets",
      "Achats Candybar"
    ].includes(finalObjet);

    const updatedData = {
      DateCollect: editDate.slice(0, 10),
      localisation: editEmplacement,
      objet: finalObjet,
      TotalAmount: parseFloat(editAmount),
      DailyExpenses: parseFloat(editExpense || 0),
      feedback: editExplanation,

      Loyers: finalObjet === "Loyers" ? parseFloat(editAmount) : 0,
      Banques: (finalObjet === "Paiement des Crédits" || finalObjet === "Agios") ? parseFloat(editAmount) : 0,
      Fisc: (finalObjet === "Déclaration fiscales" || finalObjet === "Echéancier Fiscal") ? parseFloat(editAmount) : 0,
      Salaire: finalObjet === "Les salaires" ? parseFloat(editAmount) : 0,
      Steg: finalObjet === "STEG" ? parseFloat(editAmount) : 0,
      Sonede: finalObjet === "SONEDE" ? parseFloat(editAmount) : 0,
      Cnss: finalObjet === "CNSS" ? parseFloat(editAmount) : 0,
      Assurance: finalObjet === "Assurance" ? parseFloat(editAmount) : 0,
      Entretien: finalObjet === "entretien voiture" ? parseFloat(editAmount) : 0,
      Carburant: finalObjet === "Carburant" ? parseFloat(editAmount) : 0,
      OperateurTel: finalObjet === "Opérateurs téléphoniques" ? parseFloat(editAmount) : 0,
      OperateurFibre: finalObjet === "Opérateur Internet" ? parseFloat(editAmount) : 0,
      FournituresBureau: finalObjet === "Fournitures de Bureau" ? parseFloat(editAmount) : 0,
      AchatsToys: finalObjet === "Achat jouets" ? parseFloat(editAmount) : 0,
      AchatsCandyBar: finalObjet === "Achats Candybar" ? parseFloat(editAmount) : 0,
      DeclarationFiscales: finalObjet === "Déclaration fiscales" ? parseFloat(editAmount) : 0,
      EcheancierFiscal: finalObjet === "Echéancier Fiscal" ? parseFloat(editAmount) : 0,
      PaiementCredits: finalObjet === "Paiement des Crédits" ? parseFloat(editAmount) : 0,
      Agios: finalObjet === "Agios" ? parseFloat(editAmount) : 0,
      Autres: !isStandard ? parseFloat(editAmount) : 0,
    };

    dispatch(updateChargeExp(selectedCharge._id, updatedData)).then((success) => {
      if (success) {
        setShowEditModal(false);
        setSelectedCharge(null);
      }
    });
  };

  const calculateTotals = (data) => {
    const totalAmount = data.reduce((acc, curr) => acc + (curr.TotalAmount || 0), 0);
    const totalDailyExpenses = data.reduce((acc, curr) => acc + (curr.DailyExpenses || 0), 0);
    const totalGlobal = totalAmount + totalDailyExpenses;
    return { totalAmount, totalDailyExpenses, totalGlobal };
  };

  const [totals, setTotals] = useState({ totalAmount: 0, totalDailyExpenses: 0, totalGlobal: 0 });

  const uniqueObjets = React.useMemo(() => {
    const defaultObjets = [
      "Loyers", "Paiement des Crédits", "Agios", "Déclaration fiscales", "Echéancier Fiscal",
      "Les salaires", "STEG", "SONEDE", "CNSS", "Assurance", "entretien voiture", "Carburant",
      "Opérateurs téléphoniques", "Opérateur Internet", "Fournitures de Bureau", "Achat jouets",
      "Achats Candybar"
    ];
    const cleanChargeExpl = chargeExpl || [];
    const dbObjets = cleanChargeExpl.map(item => item.objet).filter(Boolean);
    const combined = new Set([...defaultObjets, ...dbObjets]);
    return Array.from(combined);
  }, [chargeExpl]);

  const handleFilter = () => {
    setHasSearched(true);
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;

    if (start && end && start > end) {
      alert("La date de début doit être antérieure à la date de fin.");
      return;
    }

    const cleanChargeExpl = chargeExpl || [];
    const filtered = cleanChargeExpl.filter((entry) => {
      const entryDate = new Date(entry.DateCollect);

      // check filters
      const isLocationMatch = localisation === "All" || entry.localisation === localisation;
      let isObjetMatch = objet === "All" || entry.objet === objet;

      // Backward compatibility mapping for old names
      if (objet !== "All" && !isObjetMatch) {
        const oldObjetMap = {
          "Déclaration fiscales": ["Déclaration Fiscales", "Déclaration fiscales"],
          "Echéancier Fiscal": ["Echéancier Fiscale", "Echéancier Fiscal"],
          "Les salaires": ["Les Salaires", "Les salaires"],
          "entretien voiture": ["Entretien Voitures", "entretien voiture"],
          "Opérateurs téléphoniques": ["Opérateurs Téléphoniques", "Opérateurs téléphoniques"],
          "Achat jouets": ["Achats Jouets", "Achat jouets"],
          "Achats Candybar": ["Achats Candy Bar", "Achats Candybar"]
        };
        const allowedValues = oldObjetMap[objet];
        if (allowedValues) {
          isObjetMatch = allowedValues.includes(entry.objet);
        }
      }

      // Adjust date boundary to include full days
      let isDateInRange = true;
      if (start) {
        const checkStart = new Date(start);
        checkStart.setHours(0, 0, 0, 0);
        isDateInRange = isDateInRange && entryDate >= checkStart;
      }
      if (end) {
        const checkEnd = new Date(end);
        checkEnd.setHours(23, 59, 59, 999);
        isDateInRange = isDateInRange && entryDate <= checkEnd;
      }

      return isLocationMatch && isObjetMatch && isDateInRange;
    });

    // Trier par date décroissante
    filtered.sort((a, b) => new Date(b.DateCollect) - new Date(a.DateCollect));

    setFilteredData(filtered);
    setTotals(calculateTotals(filtered));
  };

  // Filtrer automatiquement au chargement des données
  useEffect(() => {
    const cleanChargeExpl = chargeExpl || [];
    if (cleanChargeExpl.length > 0) {
      handleFilter();
    }
  }, [chargeExpl]);

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.text("Etat des Depenses d'Exploitation", 14, 15);
    doc.setFontSize(10);
    doc.text(`Periode: du ${startDate || 'Debut'} au ${endDate || 'Fin'}`, 14, 22);
    doc.text(`Filtres: Emplacement: ${localisation} | Objet: ${objet}`, 14, 27);
    
    doc.autoTable({
      startY: 33,
      head: [['#', 'Date', 'Emplacement', 'Objet', 'Montant (TND)', 'Dépenses (TND)', 'Auteur']],
      body: filteredData.map((el, i) => [
        i + 1, 
        el.DateCollect ? el.DateCollect.slice(0, 10) : "", 
        el.localisation || "", 
        el.objet || "", 
        (el.TotalAmount || 0).toFixed(3), 
        (el.DailyExpenses || 0).toFixed(3),
        el.owner ? (el.owner.userName || el.owner.email || "") : ""
      ]),
      foot: [['', '', 'Total', '', totals.totalAmount.toFixed(3), totals.totalDailyExpenses.toFixed(3), `Total Global: ${totals.totalGlobal.toFixed(3)} TND`]]
    });
    doc.save(`etat_depenses_${startDate}_to_${endDate}.pdf`);
  };

  const downloadExcel = () => {
    const excelData = filteredData.map((el, i) => ({
      "#": i + 1,
      "Date": el.DateCollect ? el.DateCollect.slice(0, 10) : "",
      "Emplacement": el.localisation || "",
      "Objet": el.objet || "",
      "Montant (TND)": el.TotalAmount || 0,
      "Dépenses Associées (TND)": el.DailyExpenses || 0,
      "Explication": el.feedback || "",
      "Auteur": el.owner ? (el.owner.userName || el.owner.email || "") : ""
    }));

    // Ajouter une ligne de total à la fin
    excelData.push({
      "#": "Total",
      "Date": "",
      "Emplacement": "",
      "Objet": "",
      "Montant (TND)": totals.totalAmount,
      "Dépenses Associées (TND)": totals.totalDailyExpenses,
      "Explication": `Total Global: ${totals.totalGlobal.toFixed(3)} TND`,
      "Auteur": ""
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dépenses");
    XLSX.writeFile(workbook, `etat_depenses_${startDate}_to_${endDate}.xlsx`);
  };

  return (
    <div className="list-rapports">
      <h3>État des Dépenses d'Exploitation</h3>

      {/* Formulaire de filtrage */}
      <div className="filter-form">
        <label>
          Emplacement:
          <select value={localisation} onChange={(e) => setLocalisation(e.target.value)}>
            <option value="All">Tous les emplacements</option>
            <option>Manar City</option>
            <option>Tunisia Mall</option>
            <option>Jardins d'El Menzah</option>
            <option>Jump Zone</option>
            <option>Entourage</option>
            <option>Art & Craft</option>
            <option>Administration</option>
          </select>
        </label>

        <label>
          Objet Charge:
          <select value={objet} onChange={(e) => setObjet(e.target.value)}>
            <option value="All">Tous les types</option>
            {uniqueObjets.map((obj, idx) => (
              <option key={idx} value={obj}>{obj}</option>
            ))}
          </select>
        </label>

        <label>
          Date Début:
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </label>

        <label>
          Date Fin:
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </label>

        <button onClick={handleFilter}>Filtrer</button>
      </div>

      {/* Section des résultats */}
      {hasSearched && (
        <div className="filtered-data">
          <h3>Résultats ({filteredData.length} dépenses trouvées)</h3>
          
          <div className="results-summary">
            <div className="stat-card">
              <span className="stat-title">Montant Charges</span>
              <span className="stat-value text-primary">{totals.totalAmount.toFixed(3)} TND</span>
            </div>
            <div className="stat-card highlight-expenses">
              <span className="stat-title">Dépenses Opérationnelles</span>
              <span className="stat-value">{totals.totalDailyExpenses.toFixed(3)} TND</span>
            </div>
            <div className="stat-card highlight-net">
              <span className="stat-title">Total Global Dépenses</span>
              <span className="stat-value">{totals.totalGlobal.toFixed(3)} TND</span>
            </div>
          </div>

          {filteredData.length > 0 && (
            <div className="actions-container">
              <Button variant="primary" onClick={downloadPDF}>
                Télécharger PDF
              </Button>
              <Button variant="success" onClick={downloadExcel}>
                Télécharger Excel
              </Button>
            </div>
          )}

          {filteredData.length > 0 ? (
            <div className="table-responsive">
              <Table striped bordered hover className="table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Emplacement</th>
                    <th>Objet</th>
                    <th>Montant (TND)</th>
                    <th>Dépenses Opér. (TND)</th>
                    <th>Explication</th>
                    <th>Saisi par</th>
                    {user?.role === 'admin' && <th>Actions</th>}
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((el, i) => (
                    <tr key={i}>
                      <td>{el.DateCollect ? el.DateCollect.slice(0, 10) : "N/A"}</td>
                      <td><strong>{el.localisation}</strong></td>
                      <td><span className="badge bg-secondary">{el.objet}</span></td>
                      <td className="text-primary" style={{ fontWeight: 'bold' }}>
                        {(el.TotalAmount || 0).toFixed(3)}
                      </td>
                      <td className="text-danger">
                        {(el.DailyExpenses || 0).toFixed(3)}
                      </td>
                      <td style={{ maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={el.feedback}>
                        {el.feedback}
                      </td>
                      <td>
                        {el.owner ? (el.owner.userName || el.owner.email || "Utilisateur") : "N/A"}
                      </td>
                      {user?.role === 'admin' && (
                        <td>
                          <Button variant="outline-primary" size="sm" className="me-2" onClick={() => handleShowEdit(el)}>
                            Modifier
                          </Button>
                          <Button variant="outline-danger" size="sm" onClick={() => handleDelete(el._id)}>
                            Supprimer
                          </Button>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <p className="no-data text-center py-4">Aucune dépense enregistrée pour les critères sélectionnés.</p>
          )}
        </div>
      )}

      {/* Modal de Modification */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Modifier la Charge d'Exploitation</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleUpdate}>
          <Modal.Body>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="editEmplacement">
                <Form.Label>Emplacement</Form.Label>
                <Form.Select value={editEmplacement} onChange={(e) => setEditEmplacement(e.target.value)}>
                  <option value="">Choisissez un emplacement...</option>
                  <option>Manar City</option>
                  <option>Tunisia Mall</option>
                  <option>Jardins d'El Menzah</option>
                  <option>Jump Zone</option>
                  <option>Entourage</option>
                  <option>Art & Craft</option>
                  <option>Administration</option>
                </Form.Select>
              </Form.Group>

              <Form.Group as={Col} controlId="editObjet">
                <Form.Label>Objet de la Charge</Form.Label>
                <Form.Select value={editObjet} onChange={(e) => setEditObjet(e.target.value)}>
                  <option value="">Types de Charges...</option>
                  <option>Loyers</option>
                  <option>Paiement des Crédits</option>
                  <option>Agios</option>
                  <option>Déclaration fiscales</option>
                  <option>Echéancier Fiscal</option>
                  <option>Les salaires</option>
                  <option>STEG</option>
                  <option>SONEDE</option>
                  <option>CNSS</option>
                  <option>Assurance</option>
                  <option>entretien voiture</option>
                  <option>Carburant</option>
                  <option>Opérateurs téléphoniques</option>
                  <option>Opérateur Internet</option>
                  <option>Fournitures de Bureau</option>
                  <option>Achat jouets</option>
                  <option>Achats Candybar</option>
                  {customCategories.map((cat, idx) => (
                    <option key={idx} value={cat.name}>{cat.name}</option>
                  ))}
                  <option value="Autre">Autre (Saisir un autre objet)</option>
                </Form.Select>
              </Form.Group>
            </Row>

            {editObjet === "Autre" && (
              <Form.Group className="mb-3" controlId="editCustomObjet">
                <Form.Label>Nom de la nouvelle charge</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Saisissez l'objet de la charge..."
                  value={editCustomObjet}
                  onChange={(e) => setEditCustomObjet(e.target.value)}
                />
              </Form.Group>
            )}

            <Row className="mb-3">
              <Form.Group as={Col} controlId="editDate">
                <Form.Label>Date de la charge</Form.Label>
                <Form.Control
                  type="date"
                  value={editDate}
                  onChange={(e) => setEditDate(e.target.value)}
                />
              </Form.Group>

              <Form.Group as={Col} controlId="editAmount">
                <Form.Label>Montant Total (TND)</Form.Label>
                <Form.Control
                  type="number"
                  step="0.001"
                  placeholder="0.000"
                  value={editAmount}
                  onChange={(e) => setEditAmount(e.target.value)}
                />
              </Form.Group>

              <Form.Group as={Col} controlId="editExpense">
                <Form.Label>Dépenses associées (TND)</Form.Label>
                <Form.Control
                  type="number"
                  step="0.001"
                  placeholder="0.000"
                  value={editExpense}
                  onChange={(e) => setEditExpense(e.target.value)}
                />
              </Form.Group>
            </Row>

            <Form.Group className="mb-3" controlId="editExplanation">
              <Form.Label>Explication</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Donnez une explication détaillée de la dépense..."
                value={editExplanation}
                onChange={(e) => setEditExplanation(e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              Annuler
            </Button>
            <Button variant="primary" type="submit">
              Enregistrer les modifications
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default EtatDepenses;
